<!-- <div id="global-loader" class="global-loader" *ngIf="isLoadingCounts">
  <div class="spinner"></div>
</div> -->

<div class="page-card bg-white border rounded-3 shadow-sm p-3  position-relative" [ngStyle]="{'height': scrHeight}" style="overflow: auto;">

  <div class="d-flex align-items-center gap-3">
    <label class="section-title mb-1 ms-2">Select Departments &amp; Team Members</label>

    <div
      *ngIf="selectedDepartmentIds.length === 0"
      class="hint-banner position-absolute d-none d-md-flex align-items-center gap-2 rounded-2 px-2 py-1"
    >
      <mat-icon class="hint-icon">info</mat-icon>
      <span class="d-none d-lg-inline">Select at least one department and one team member to proceed to the next step</span>
      <span class="d-lg-none">Select department &amp; member to proceed</span>
    </div>
  </div>

  <!-- 3-Column Grid -->
  <div class="row g-3 mt-1 mx-0 mb-2">

    <!-- Panel 1: Departments -->
    <div class="col-12 col-md-6 desktop-33">
      <section class="panel rounded-3 p-3 overflow-auto">
        <!-- Header -->
        <header class="panel-header d-flex align-items-center justify-content-between mb-2">
          <div class="d-inline-flex align-items-center gap-2 panel-title">
            <mat-icon class="title-icon">domain</mat-icon>
            <label>Departments ({{ selectedDepartmentIds.length }} selected)</label>
          </div>

          <div class="d-inline-flex align-items-center gap-2">
            <button
              class="btn btn-brand btn-xs d-inline-flex align-items-center gap-1 text-white rounded-3 px-2 py-1"
              (click)="toggleSort()"
              title="Sort A–Z / Z–A"
            >
              <span>{{ isAscending ? 'A–Z' : 'Z–A' }}</span>
            </button>
            <button
              class="btn btn-brand btn-xs d-inline-flex align-items-center gap-1 text-white rounded-3 px-2 py-1"
              (click)="openSearchUserModal()"
              title="Search User"
            >
              <mat-icon class="search-user-icon">person_search</mat-icon>
            </button>
          </div>
        </header>

        <!-- Search -->
        <div class="search-box d-flex align-items-center gap-2 border rounded-2 px-2 py-2 mb-2">
          <mat-icon class="search-icon">search</mat-icon>
          <input
            type="text"
            class="flex-grow-1 border-0 bg-transparent search-input"
            placeholder="Search departments, names, or emails..."
            [(ngModel)]="searchText"
            (ngModelChange)="onDepartmentSearchChange($event)"
          />
        </div>

        <!-- Department List -->
        <div class="panel-scroll pe-2" (scroll)="onDeptListScroll($event)">
          <ng-container *ngFor="let group of departmentGroups; trackBy: trackByGroupLetter; ">
            <div class="list-letter" [class.star-group]="group.letter === '★'">{{ group.letter }}</div>

            <div class="d-flex flex-column gap-2">
              <div
                class="list-card dept-item d-flex align-items-center justify-content-between gap-3 bg-white"
                *ngFor="let dept of group.departments; trackBy: trackByDeptId"
                [class.dept-item--selected]="selectedDepartmentIds.includes(dept.id)"
                (click)="selectDepartment(dept)"
                role="button"
              >
                <div class="d-flex flex-column gap-1">
                  <div class="dept-name">{{ dept.name }}</div>
                  <div class="dept-subtext">{{ dept.count }} members</div>
                </div>

                <span
                  class="star-icon d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                  [class.star-filled]="dept.isFavorite"
                  [matTooltip]="dept.isFavorite ? 'Remove from favorites' : 'Add to favorites'"
                  (click)="toggleFavoriteDept(dept); $event.stopPropagation()"
                  role="button"
                  aria-label="Toggle favorite"
                >
                  <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
                    <path
                      d="M12 17.27 L18.18 21 L16.54 13.97 L22 9.24 L14.81 8.63 L12 2 L9.19 8.63 L2 9.24 L7.46 13.97 L5.82 21 Z"
                      [attr.fill]="dept.isFavorite ? '#cc0000' : 'none'"
                      [attr.stroke]="dept.isFavorite ? '#cc0000' : 'currentColor'"
                      stroke-width="2.25"
                    ></path>
                  </svg>
                </span>
              </div>
            </div>
          </ng-container>

          <!-- Scroll-load indicator -->
          <div *ngIf="isLoadingMore" class="d-flex justify-content-center py-2">
            <div class="spinner-border spinner-border-sm text-secondary" role="status">
              <span class="visually-hidden">Loading more departments…</span>
            </div>
          </div>
          <div *ngIf="allDepartmentsLoaded && departmentGroups.length > 0" class="text-center text-muted small py-2">
            All departments loaded
          </div>
        </div>
      </section>
    </div>

    <!-- Panel 2: Team Members -->
    <div class="col-12 col-md-6 desktop-38">
      <section class="panel rounded-3 p-3 overflow-auto">
        <header class="panel-header d-flex align-items-center justify-content-between mb-2">
          <div class="d-inline-flex align-items-center gap-2 panel-title">
            <mat-icon class="title-icon">people_outline</mat-icon>
            <label>Team Members ({{ totalTeamMemberCount }} available)</label>
          </div>
        </header>

        <div class="d-flex flex-column flex-grow-1">
          <div class="search-box d-flex align-items-center gap-2 border rounded-2 px-2 py-2 mb-2"
            *ngIf="selectedDepartmentIds.length > 0">
            <mat-icon class="search-icon">search</mat-icon>
            <input
              type="text"
              class="flex-grow-1 border-0 bg-transparent search-input"
              placeholder="Search team members..."
              [(ngModel)]="memberSearchText"
            />
          </div>

          <div class="placeholder flex-grow-1 d-flex align-items-center justify-content-center" 
            *ngIf="selectedDepartmentIds.length === 0">
            <div class="placeholder-inner d-inline-flex flex-column align-items-center justify-content-center gap-2 text-center">
              <mat-icon class="placeholder-icon">business</mat-icon>
              <div class="placeholder-text">Select a department to view team members</div>
            </div>
          </div>

          <div class="d-flex flex-column gap-3" *ngIf="selectedDepartmentIds.length > 0">
            <div
              class="dept-tab d-flex flex-column border rounded-3 overflow-hidden"
              *ngFor="let dept of filteredSelectedDepartmentsForTabs; trackBy: trackByDeptId"
            >
              <div class="dept-tab-header d-flex flex-column align-items-start px-2 py-1" [class.dept-tab-open]="isMiddleDeptOpen(dept.id)">
                <div class="d-flex align-items-center gap-2 mb-0 w-100 dept-row">
                  <button
                    class="btn p-0 border-0 bg-transparent d-inline-flex align-items-center justify-content-center chevron-btn"
                    (click)="toggleMiddleDept(dept.id)"
                    title="Expand/Collapse"
                    [class.open]="isMiddleDeptOpen(dept.id)"
                    aria-label="Expand/Collapse"
                  >
                    <mat-icon class="chevron">chevron_right</mat-icon>
                  </button>

                  <div class="dept-row-title flex-grow-1">
                    {{ dept.name }}
                    <label class="dept-row-count">({{ getMemberCountForDept(dept.id) }})</label>
                  </div>

                  <button
                    class="btn d-inline-flex align-items-center justify-content-center rounded-circle border p-0 remove-btn dept-close-btn"
                    (click)="removeDepartment(dept, $event)"
                    title="Remove department"
                    aria-label="Remove department"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
                <div class="buttons">
                  <button
                    class="btn p-0 border-0 bg-transparent d-inline-flex align-items-center gap-1 ms-2 text-brand select-all-btn"
                    *ngIf="getMemberCountForDept(dept.id) > 0"
                    [disabled]="!allMembers[dept.id] || allMembers[dept.id].length === 0"
                    (click)="toggleDeptSelectAllButton(dept.id)"
                    title="Select all in this department">
                    <mat-icon class="text-brand">{{ getDeptSelectAllIcon(dept.id) }}</mat-icon>
                    <span>Select All</span>
                  </button>
                  <button
                    class="btn p-0 border-0 bg-transparent d-inline-flex align-items-center gap-1 ms-2 text-brand select-all-btn"
                    *ngIf="getMemberCountForDept(dept.id) > 0"
                    [disabled]="!allMembers[dept.id] || allMembers[dept.id].length === 0 || !hasFavoriteMembers(dept.id)"
                    (click)="toggleDeptSelectFavoriteButton(dept.id)"
                    title="Select favorite in this department">
                    <mat-icon class="text-brand">{{ getDeptSelectFavoriteIcon(dept.id) }}</mat-icon>
                    <span>Select Favourite</span>
                  </button>
                </div>
              </div>

              <div
                class="member-loading d-flex align-items-center justify-content-center px-3 py-2"
                *ngIf="isMiddleDeptOpen(dept.id) && isDeptLoadingMembers(dept.id)"
              >
                <div class="spinner-border spinner-border-sm text-brand me-2" role="status" aria-hidden="true"></div>
                <span>Loading team members...</span>
              </div>

              <div
                class="no-members d-flex flex-column align-items-center justify-content-center gap-2 text-center"
                *ngIf="isMiddleDeptOpen(dept.id) && !isDeptLoadingMembers(dept.id) && getMemberCountForDept(dept.id) === 0"
              >
                <mat-icon class="no-members__icon">people_outline</mat-icon>
                <span>No team members found</span>
              </div>

              <div
                class="member-list px-3 py-2"
                *ngIf="isMiddleDeptOpen(dept.id) && getMemberCountForDept(dept.id) > 0">
                <div class="d-flex flex-column gap-2 pe-1">
                  <ng-container *ngFor="let member of getMembersForDept(dept.id); trackBy: trackByMemberId">
                    <div class="member-card list-card w-100 text-break p-2" [class.member--selected]="member.selected">
                      <button
                        class="btn p-0 border-0 bg-transparent d-inline-flex align-items-center justify-content-center"
                        (click)="toggleTeamMemberSelection(member, $event)"
                        title="Select"
                        aria-label="Select">
                        <mat-icon [class.text-brand]="member.selected" class="checkbox-icon">
                          {{ member.selected ? 'check_box' : 'check_box_outline_blank' }}
                        </mat-icon>
                      </button>

                      <div class="avatar" [class.avatar-selected]="member.selected">
                        {{ getInitials(member.name) }}
                      </div>

                      <div class="d-flex flex-column gap-1">
                        <!-- <div class="d-flex flex-row gap-1"> -->
                          <div class="member-name">
                            {{ member.name }}
                            <span class="member-email" *ngIf="member.email"> - {{ member.email }}</span>
                          </div>
                          <!-- <div class="member-level"> - {{ member.level }}</div> -->
                        <!-- </div> -->
                        <div class="member-role">{{ member.role }}</div>
                      </div>

                      <div>
                        <span class="star-icon d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                          [class.star-filled]="member.isFavorite" [matTooltip]="member.isFavorite ? 'Remove from favorites' : 'Add to favorites'"
                           role="button" aria-label="Toggle favorite" (click)="teammemberFavorite(member, dept.id, $event)">
                          <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
                            <path d="M12 17.27 L18.18 21 L16.54 13.97 L22 9.24 L14.81 8.63 L12 2 L9.19 8.63 L2 9.24 L7.46 13.97 L5.82 21 Z"
                              [attr.fill]="member.isFavorite ? '#cc0000' : 'none'" [attr.stroke]="member.isFavorite ? '#cc0000' : 'currentColor'"
                              stroke-width="2.25"></path>
                          </svg>
                        </span>
                      </div>

                      <!-- <div class="member-level">{{ member.level }}</div> -->
                       <!-- *ngIf="member.level"  {{ member.level }} -->

                      </div>
                  </ng-container>
                </div>
               
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- Panel 3: Selected Team Members -->
    <div class="col-12 desktop-29">
      <section
        class="selected-panel d-flex flex-column border rounded-3 p-3 bg-white overflow-auto"
        [class.d-flex]="selectedMembers.length === 0"
        [class.d-block]="selectedMembers.length > 0"
      >
        <header class="panel-header d-flex align-items-center justify-content-between mb-2">
          <div class="d-inline-flex align-items-center gap-2 panel-title">
            <label>Selected Team Members ({{ selectedMembers.length }})</label>
          </div>
          <button class="btn p-0 border-0 bg-transparent text-brand" (click)="clearSelectedMembersOnly()">Clear All</button>
        </header>

        <div class="placeholder flex-grow-1 d-flex align-items-center justify-content-center" *ngIf="selectedMembers.length === 0">
          <div class="placeholder-inner d-inline-flex flex-column align-items-center justify-content-center gap-2 text-center">
            <mat-icon class="placeholder-icon">people_outline</mat-icon>
            <div class="placeholder-text">
              No members selected<br />
              <small>Select team members to add them here</small>
            </div>
          </div>
        </div>

        <div class="d-flex flex-column flex-grow-1 overflow-auto min-h-0" *ngIf="selectedMembers.length > 0">
          <div class="selected-row" *ngFor="let dept of filteredDepartmentsWithMembers; trackBy: trackByDeptId">
            <button
              class="btn w-100 d-grid align-items-center gap-2 px-0 py-1 border-0 bg-transparent selected-dept-btn"
              (click)="toggleSelectedDept(dept)"
              [class.open]="isSelectedDeptOpen(dept)"
              title="Expand/Collapse"
              aria-label="Expand/Collapse"
            >
              <mat-icon class="chevron text-brand">chevron_right</mat-icon>
              <span class="selected-dept-name text-brand">{{ dept.name }}</span>
              <span class="selected-dept-count">({{ getSelectedCountForDept(dept.id) }})</span>
            </button>

            <div class="selected-members" *ngIf="isSelectedDeptOpen(dept)">
              <div class="overflow-auto py-1">
                <div
                  class="selected-member-row d-grid align-items-center gap-2 border rounded-3 px-2 py-2 mb-2 w-100 text-break"
                  *ngFor="let member of getSelectedMembersForDept(dept.id); trackBy: trackByMemberId"
                >
                  <div class="avatar avatar-soft text-brand">{{ getInitials(member.name) }}</div>

                  <div class="d-flex flex-column gap-1">
                    <div class="member-name">{{ member.name }}</div>
                    <div class="member-role">{{ member.role }}</div>
                  </div>

                  <button
                    class="btn d-inline-flex align-items-center justify-content-center rounded-circle border p-0 remove-btn"
                    (click)="member.selected = false; updateSelectedMembers()"
                    title="Remove"
                    aria-label="Remove"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div> <!-- /selected-row -->
        </div>
      </section>
    </div>

  </div>
</div>
